// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Rating.less';

const width = value => {
    let result = Math.ceil(value * 20 / 5) * 5;
    if (result % 20 === 5) {
        result += 2;
    } else if (result % 20 === 15) {
        result -= 2;
    }

    return result;
};

/**
 * Rating component.
 */
const Rating = ({
    baseClassName,
    className,
    value,
    small,
    ...props
}) => (
    <div
        className={classNames({
            [baseClassName]: true,
            [`${baseClassName}--static`]: true,
            [`${baseClassName}--small`]: small,
            [className]: true,
        })}
        {...props}
    >
        <div className={`${baseClassName}__rates`} style={{ width: `${width(value)}%` }} />
    </div>
);

Rating.propTypes = {
    /**
     * Rating value from 0 to 5.
     */
    value: PropTypes.number,
    /**
     * Small variant.
     */
    small: PropTypes.bool,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Rating.defaultProps = {
    value: 0,
    small: false,
    className: null,
    baseClassName: `${CLS_PREFIX}rating`,
};

export default Rating;



// WEBPACK FOOTER //
// ./components/Rating/Rating.js